import React, { useState, useEffect } from "react";
import axios from "axios";
import { useUser } from "./Context/UserContext";
import {
    Table,
    Container,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Input,
} from "reactstrap";
import "../styles/ViewAllVendors.css";
import { Link } from "react-router-dom";
import profileImg from "../assets/logo.png";
import VendorInfoTabs from "./VendorInfoTabs";
import DashboardLayout from "../../src/components/DashboardLayout";
const VendorRegistrationDetails = () => {
    const [approvalHistory, setApprovalHistory] = useState([]);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [vendors, setVendors] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const { user } = useUser();
    const [showCard, setShowCard] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [activeTab, setActiveTab] = useState("details");
    const [approvalStatuses, setApprovalStatuses] = useState([]);
    const [comment, setComment] = useState("");
    const [approvalError, setApprovalError] = useState("");
    const [commentError, setCommentError] = useState("");
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [subTab, setSubTab] = useState("details");
    useEffect(() => {
        const fetchData = async () => {
            try {
                const vendorResponse = await axios.get(
                    "/api/vendordetails/details",
                );
                setVendors(vendorResponse.data);
            } catch (err) {
                console.error("Error fetching vendors:", err);
            }
        };
        fetchData();
    }, []);
    const [users, setUsers] = useState([]);
    useEffect(() => {
        if (selectedVendor && selectedVendor.userId) {
            axios
                .get(
                    `/api/approvalstatus/${selectedVendor.userId}`,
                )
                .then((response) => {
                    setUsers(response.data || []);
                })
                .catch((error) => {
                    console.error("Error fetching approval status:", error);
                });
        }
    }, [selectedVendor]);
    useEffect(() => {
        const dark = localStorage.getItem("darkMode") === "true";
        document.body.classList.toggle("dark-mode", dark);
    }, []);
    const vendorsPerPage = 6;
    const startIndex = (currentPage - 1) * vendorsPerPage;
    const totalPages = Math.ceil(vendors.length / vendorsPerPage);
    const vendorsForPage = vendors.slice(startIndex, startIndex + vendorsPerPage);
    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "Invalid Date";
        return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
    };
    const handlePageChange = (type) => {
        if (type === "first") setCurrentPage(1);
        if (type === "prev" && currentPage > 1) setCurrentPage(currentPage - 1);
        if (type === "next" && currentPage < totalPages)
            setCurrentPage(currentPage + 1);
        if (type === "last") setCurrentPage(totalPages);
    };
    const handleReviewClick = (index) => {
        const vendor = vendors[index];
        setSelectedVendor({
            ...vendor,
            userId:
                vendor.userId || vendor.UserId || vendor.userid || vendor.id || null,
            index,
        });
        setShowModal(true);
        setIsEditing(false);
        setActiveTab("history");
    };
    const handleInputChange = (e, field) => {
        setSelectedVendor({ ...selectedVendor, [field]: e.target.value });
    };
    const handleSave = () => {
        if (selectedVendor && selectedVendor.index !== undefined) {
            const updatedVendors = [...vendors];
            updatedVendors[selectedVendor.index] = { ...selectedVendor };
            delete updatedVendors[selectedVendor.index].index;
            setVendors(updatedVendors);
        }
        setIsEditing(false);
        setShowModal(false);
    };
    const handleSort = (column) => {
        const sortedVendors = [...vendors].sort((a, b) => {
            let valueA = a[column]?.toString().toLowerCase() || "";
            let valueB = b[column]?.toString().toLowerCase() || "";
            if (sortOrder === "asc") {
                return valueA > valueB ? 1 : -1;
            } else {
                return valueA < valueB ? 1 : -1;
            }
        });
        setVendors(sortedVendors);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        setSortBy(column);
    };
    const handleApprove = async () => {
        let isValid = true;
        setApprovalError("");
        setCommentError("");
        if (!selectedVendor?.p_isApproved) {
            setApprovalError("This field is required");
            isValid = false;
        }
        if (!comment || comment.trim() === "") {
            setCommentError("This field is required");
            isValid = false;
        }
        if (!selectedVendor?.p_userID) {
            console.error("Missing user ID");
            isValid = false;
        }
        if (!isValid) return;
        try {
            const approvalValue = selectedVendor.p_isApproved === "approved" ? 4 : 5;
            const response = await axios.post(
                "/api/vendor/update-approval",
                {
                    p_userID: selectedVendor.p_userID,
                    p_isApproved: approvalValue,
                    comment: comment,
                },
            );
            if (response.status === 200) {
                alert("Approval status updated successfully.");
            } else {
                alert("Failed to update approval status.");
            }
        } catch (error) {
            console.error("Error updating approval status:", error);
            alert("Something went wrong while updating approval status.");
        }
        setShowModal(false);
    };
    const handleReject = () => {
        if (selectedVendor && selectedVendor.index !== undefined) {
            const updatedVendors = [...vendors];
            updatedVendors[selectedVendor.index].approvalStatus = "Rejected";
            setVendors(updatedVendors);
        }
        setShowModal(false);
    };
    return (
        <DashboardLayout>
            <Container>
                <h2 className="page-title" style={{ marginTop: 0, marginBottom: '20px', color: '#0a4275', paddingTop: '50px' }}>
                    Vendors Details
                </h2>
                <Table bordered className="vendor-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Company Name</th>
                            <th>Contact Person</th>
                            <th>Nature of Supply</th>
                            <th>MSME</th>
                            <th>PAN Number</th>
                            <th>GST Number</th>
                            <th>HSN/SAC Code</th>
                            <th
                                onClick={() => handleSort("approvalStatus")}
                                style={{ cursor: "pointer" }}
                            >
                                Approval Status{" "}
                                {sortBy === "approvalStatus"
                                    ? sortOrder === "asc"
                                        ? "▲"
                                        : "▼"
                                    : "⇅"}
                            </th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {vendorsForPage.map((vendor, index) => (
                            <tr key={vendor.vendorCode || index}>
                                <td>{startIndex + index + 1}</td>
                                <td>{vendor.legalName}</td>
                                <td>{vendor.contactPersonName || "N/A"}</td>
                                <td>{vendor.natureOfSupply}</td>
                                <td>{vendor.msmeNo || "N/A"}</td>
                                <td>{vendor.pan || "N/A"}</td>
                                <td>{vendor.gst || "N/A"}</td>
                                <td>{vendor.hsNsacCode || "N/A"}</td>
                                <td>{vendor.approvalStatus || "N/A"}</td>
                                <td>
                                    <button
                                        className="review-btn"
                                        onClick={() => handleReviewClick(startIndex + index)}
                                    >
                                        Review
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                <div className="pagination">
                    <button
                        onClick={() => handlePageChange("first")}
                        disabled={currentPage === 1}
                    >
                        First
                    </button>
                    <button
                        onClick={() => handlePageChange("prev")}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    <span className="page-info">
                        Page {currentPage} of {totalPages}
                    </span>
                    <button
                        onClick={() => handlePageChange("next")}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                    <button
                        onClick={() => handlePageChange("last")}
                        disabled={currentPage === totalPages}
                    >
                        Last
                    </button>
                </div>
                <Modal
                    isOpen={showModal}
                    toggle={() => setShowModal(false)}
                    centered
                    className="modal-lg custom-modal"
                >
                    <ModalHeader toggle={() => setShowModal(false)}>
                        Vendor Details
                    </ModalHeader>
                    <div className="tabs1">
                        <span
                            className={activeTab === "history" ? "active-tab" : ""}
                            onClick={() => setActiveTab("history")}
                        >
                            Vendor Approval History
                        </span>
                        <span
                            className={activeTab === "info" ? "active-tab" : ""}
                            onClick={() => setActiveTab("info")}
                        >
                            Info
                        </span>
                        <span
                            className={activeTab === "details" ? "active-tab" : ""}
                            onClick={() => setActiveTab("details")}
                        >
                            Approve/Reject
                        </span>
                    </div>
                    <ModalBody>
                        {activeTab === "history" && selectedVendor && (
                            <div className="history-container">
                                <Table bordered className="history-table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Approval Status</th>
                                            <th>Approver Name</th>
                                            <th>Date</th>
                                            <th>Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {users.length > 0 ? (
                                            users.map((user, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{user.approvalStatus || "N/A"}</td>
                                                    <td>{user.approvalName || "N/A"}</td>
                                                    <td>
                                                        {user.createDate
                                                            ? (() => {
                                                                const date = new Date(user.createDate);
                                                                const day = String(date.getDate()).padStart(
                                                                    2,
                                                                    "0",
                                                                );
                                                                const month = String(
                                                                    date.getMonth() + 1,
                                                                ).padStart(2, "0");
                                                                const year = date.getFullYear();
                                                                return `${day}-${month}-${year}`;
                                                            })()
                                                            : "N/A"}
                                                    </td>
                                                    <td>{user.comments || "N/A"}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center">
                                                    No history found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        )}
                        {activeTab === "info" && selectedVendor && (
                            <VendorInfoTabs
                                selectedVendor={selectedVendor}
                                isEditing={isEditing}
                                setIsEditing={setIsEditing}
                                handleInputChange={handleInputChange}
                                subTab={subTab}
                                setSubTab={setSubTab}
                                type="vendor"
                            />
                        )}
                        {activeTab === "details" && selectedVendor && (
                            <div className="details-container">
                                <ModalBody>
                                    <p>
                                        <strong>Company Name:</strong> {selectedVendor?.legalName}
                                    </p>
                                    <div>
                                        <label>
                                            <strong>Approval Status:</strong>
                                        </label>
                                        <span className="required-field">
                                            *
                                            {approvalError && (
                                                <span className="error-texts">{approvalError}</span>
                                            )}
                                        </span>
                                        <Input
                                            type="select"
                                            className="approval-dropdown"
                                            value={selectedVendor?.p_isApproved || ""}
                                            onChange={(e) => {
                                                const selectedValue = e.target.value;
                                                setSelectedVendor((prev) => ({
                                                    ...prev,
                                                    p_isApproved: selectedValue,
                                                    p_userID: prev?.p_userID || prev?.id || prev?.userID,
                                                }));
                                            }}
                                        >
                                            <option value="">Select</option>
                                            <option value="approved">Approved</option>
                                            <option value="rejected">Rejected</option>
                                        </Input>
                                    </div>
                                    <div className="comment-section">
                                        <label>
                                            <strong>Comment:</strong>
                                        </label>
                                        <span className="required-field">
                                            *
                                            {commentError && (
                                                <span className="error-text1"> {commentError}</span>
                                            )}
                                        </span>
                                        <Input
                                            type="textarea"
                                            value={comment}
                                            onChange={(e) => {
                                                setComment(e.target.value);
                                                setCommentError("");
                                            }}
                                            placeholder="Enter your comment here..."
                                        />
                                    </div>
                                </ModalBody>
                                <div className="footer-section">
                                    <Button color="success" onClick={handleApprove}>
                                        Save
                                    </Button>
                                    <Button color="danger" onClick={() => setShowModal(false)}>
                                        Close
                                    </Button>
                                </div>
                            </div>
                        )}
                    </ModalBody>
                </Modal>
            </Container>
        </DashboardLayout>
    );
};
export default VendorRegistrationDetails;
